import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"background-color":"#f4f8fa"},
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Management Proses")
  ])
], -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row fv-row mb-5 mt-5" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-xl-4" }
const _hoisted_8 = { class: "col-xl-4" }
const _hoisted_9 = { class: "col-xl-4" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xl-4" }
const _hoisted_12 = { class: "col-xl-4" }
const _hoisted_13 = { class: "col-xl-4" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-xl-4" }
const _hoisted_16 = { class: "col-xl-4" }
const _hoisted_17 = { class: "col-xl-4" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-xl-4" }
const _hoisted_20 = { class: "col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.childData == true)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "light",
                      "chart-height": "230",
                      chartTitle: "Webinar",
                      tes: _ctx.dataWebinar,
                      colorStick: _ctx.colorWebinar,
                      jumlah: _ctx.totalWebinar
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "danger",
                      "chart-height": "230",
                      chartTitle: "Presentasi",
                      tes: _ctx.dataPresentation,
                      colorStick: _ctx.colorPresentation,
                      jumlah: _ctx.totalPresentation
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "info",
                      "chart-height": "230",
                      chartTitle: "Proposal",
                      tes: _ctx.dataProposal,
                      colorStick: _ctx.colorProposal,
                      jumlah: _ctx.totalProposal
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "primary",
                      "chart-height": "230",
                      chartTitle: "FollowUp",
                      tes: _ctx.dataFollowUp,
                      colorStick: _ctx.colorFollowUp,
                      jumlah: _ctx.totalFollowUp
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "danger",
                      "chart-height": "230",
                      chartTitle: "PKS",
                      tes: _ctx.dataContract,
                      colorStick: _ctx.colorContract,
                      jumlah: _ctx.totalContract
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "primary",
                      "chart-height": "230",
                      chartTitle: "Pengumpulan Data",
                      tes: _ctx.dataCollect,
                      colorStick: _ctx.colorCollect,
                      jumlah: _ctx.totalDataCollect
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "info",
                      "chart-height": "230",
                      chartTitle: "Pre Implementasi",
                      tes: _ctx.dataPreImplementasi,
                      colorStick: _ctx.colorPreImplementasi,
                      jumlah: _ctx.totalPreImplementasi
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "info",
                      "chart-height": "230",
                      chartTitle: "Tagihan",
                      tes: _ctx.dataBilling,
                      colorStick: _ctx.colorBilling,
                      jumlah: _ctx.totalBilling
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "primary",
                      "chart-height": "230",
                      chartTitle: "Implementasi",
                      tes: _ctx.dataImplementasi,
                      colorStick: _ctx.colorImplementasi,
                      jumlah: _ctx.totalImplementasi
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "danger",
                      "chart-height": "230",
                      chartTitle: "After Sales",
                      tes: _ctx.dataAfterSales,
                      colorStick: _ctx.colorAfterSales,
                      jumlah: _ctx.totalAfterSales
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Chart, {
                      "widget-classes": "card-xl-stretch mb-xl-8",
                      "widget-color": "info",
                      "chart-height": "230",
                      chartTitle: "Total Semuanya",
                      tes: _ctx.dataTotal,
                      colorStick: _ctx.colorTotal,
                      jumlah: _ctx.totalTotal
                    }, null, 8, ["tes", "colorStick", "jumlah"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}